import React from "react";

import "../../App.scss";

import CardActions from "@mui/material/CardActions";

import Typography from "@mui/material/Typography";

import { useNavigate } from "react-router-dom";

import ProjectHandleling from "./ProjectHandeling";
import universalstorageHandler, { enumStorageMode } from "../../persistence/UniversalstorageHandler";

export default function ExampleProjectCard(props: { projectHandleling: ProjectHandleling }) {
  const { projectHandleling } = props;
  const navigate = useNavigate();

  const exampleProjectId = "feb4517d-4cd6-18e5-fd82-1150da9e019f";

  function Content() {
    return (
      <div style={{ position: "relative", padding: "10px" }}>
        <Typography
          variant="h5" // no itx
          component="div" // no itx
        >
          <div
            id="projectName"
            style={{
              // backgroundColor: "var(--primary-color)",
              cursor: "text",
            }}
          >
            {state.translate("exampleProjectCard.exampleProject", "Beispiel-Projekt")}
          </div>
          <div
            style={{
              fontSize: "16px",
            }}
          >
            {state.translate(
              "exampleProjectCard.exampleProjectDescription",
              "Hier können Sie ein Beispiel-Projekt laden",
            )}
          </div>
        </Typography>
      </div>
    );
  }

  function Buttons() {
    const style: any = {
      //   display: "flex",
      //   flexDirection: "row",
      //   gap: "1px",
      //alignSelf: "center",
    };
    async function copyExampleProjectFromServer(ev: any) {
      /// here load the exampleProject from Server
      //then edit the Id of the metadata, user(inside of project)
      const newName = state.translate("exampleProjectCard.example", "Beispiel");

      projectHandleling.copyProject(
        exampleProjectId,
        ev,
        navigate,
        state.translate(
          "exampleProjectCard.exampleProjectDescriptionAfterLoading",
          "Entdecke alle Funktionen anhand eines Beispiels",
        ),
        true,
        newName,
      );
    }

    return (
      <CardActions style={{ alignSelf: "center" }}>
        <button
          style={style}
          className="button"
          onClick={(ev) => {
            ev.stopPropagation();
            const elm: any = ev.target;
            elm.innerHTML = state.translate("homePage.loading", "Loading ...");
            elm.style.backgroundColor = "var(--projectSelection-buttonActive-BackgoundColor)"; // no itx
            copyExampleProjectFromServer(ev);
          }}
        >
          {/* <i className={`las la-caret-square-up`}></i> */}
          {state.translate("homePage.load", "Load")}
        </button>
      </CardActions>
    );
  }

  ///////////////////////////////////////////////////////////////////////////////
  if (universalstorageHandler.storageMode != enumStorageMode.local) {
    return (
      <div
        id={"ExampleProjectCard"} // no itx
        key={"ExampleProjectCard"} // no itx
        className={"projectSelectionCard"}
        style={{ backgroundColor: "var(--primary-color-light)" }}
      >
        <Content />
        <Buttons />
      </div>
    );
  } else {
    return (
      <div
        id={"ExampleProjectCard"} // no itx
        key={"ExampleProjectCard"} // no itx
        className={"projectSelectionCard"}
        style={{ backgroundColor: "var(--primary-color-light)" }}
      >
        <div style={{ width: "500px" }}>{state.translate("exampleProjectCard.inLocalStorage", "local storage")} </div>
      </div>
    );
  }
}
